<template>
    <div
        @click="goToMachineList(element.packageServiceType)"
        class="quick-notification-item d-flex flex-row p-2"
    >
        <div class="d-flex justify-content-center" style="width: 4rem">
            <img
                style="width: 3.5rem; height: 3.5rem"
                :src="`/icon/notification/${element.notificationId}.svg`"
            />
        </div>
        <div
            class="d-flex flex-column flex-fill"
            style="width: 1%; margin-left: 0.5rem"
        >
            <div>
                <span>Machine</span>
                <span style="font-weight: 500">
                    &nbsp;#{{ element.machineId }} ({{
                        element.machineName
                    }})&nbsp;
                </span>
                <span>booted successfully.</span>
            </div>
            <div style="font-size: 0.8rem; color: #42a5f5">
                {{ element.createdAt | pretyDateUtcToLocal }}
            </div>
        </div>
        <div
            v-if="!element.read"
            class="d-flex flex-row align-items-center justify-content-center ml-1 mr-1"
        >
            <div
                style="
                    height: 12px;
                    width: 12px;
                    border-radius: 1rem;
                    background-color: forestgreen;
                "
            ></div>
        </div>
    </div>
</template>

<script>
// Extend
import baseNotificationsService from "@/scripts/notifications/baseNotificationsService";

export default {
    extends: baseNotificationsService,

    props: {
        element: {
            type: Object,
            default: null,
        },
    },

    methods: {
        //#region Go to machine list
        goToMachineList(serviceType) {
            this.$root.$emit("bv::hide::popover");
            this.pushUrl(
                serviceType === 1 ? this.routeUrl.GPUHUB : this.routeUrl.CPUHUB
            );
            this.markStatus(this.element.id);
        },
        //#endregion
    },
};
</script>